import { FetchEditionsOptions, QUERY_KEYS } from '@24i/nxg-sdk-photon';

import { PagesResponseGuard } from './guards';
import { mapPageSection } from './mappers';
import { SharedContentDataClient } from './shared';

export class ContentDataClient extends SharedContentDataClient {
    async fetchPage(pageId?: string, options?: FetchEditionsOptions) {
        if (!pageId) {
            return [];
        }
        const queryFn = () =>
            this.request({
                path: `/pages/${pageId}`,
                method: 'GET',
                query: {
                    includeItems: false,
                },
                guard: PagesResponseGuard,
            }).then((response) => response?.map(mapPageSection) || []);

        if (options?.suppressCache) {
            return queryFn();
        }

        return this.query({ key: [QUERY_KEYS.page, pageId], queryFn });
    }
}
